import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import { ChromePicker } from 'react-color';
import { TextValidator } from 'react-material-ui-form-validator';
import { Grid, Box, FormControl, Button, Dialog, DialogContent, DialogActions, Tabs, Tab } from '@material-ui/core';
import { UploadComponent } from '../../components';

import useStyles from './styles.js';

class EventPopover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openEditDiv : false,
            currentItem:  this.props.items && this.props.items[Object.keys(this.props.items)[0]],
            activeTab: 0,
            items: this.props.items
        }
        
    }

    /** Life cycle methods */
    componentDidMount() {}

    componentWillUnmount() {}

    /** Event Handlers */
    handleTabChange = (e,value) =>{
        let state = this.state;
        let items = state.items;      
        let currentItem =  items && items[Object.keys(items)[value]];

        this.setState({
            activeTab:value,
            currentItem: currentItem
        })
    }

	handleColorChange(color, field){
		let items = this.state.items;
		items[field]["value"] = color.hex;
		this.setState({ items });
	}

    handleChange=(e)=>{
        let items = this.state.items;
        items[e.target.name]["value"] = e.target.value;
        this.setState({
            items : items
        })
    }

    successCallback(data){
        let items = this.state.items;
        items[this.state.currentItem.name]["value"] = data
       this.setState({
            items : items
       })
    }

    failureCallback(error){
        console.log("Error", error);
    }

    /** Render views */
    renderTabSpecificView(classes){
        let viewJSX = [];
        let currentItem = this.state.currentItem;
        
        if(currentItem && currentItem.upload){
            viewJSX.push(
                <div className={classes.popOverDiv}>
                    <div>{currentItem.value ? null : null}</div>
                    <UploadComponent 
                        accept={ currentItem.accept}
                        isDisabled={currentItem.disabled}
                        bucketName={currentItem.name == 'disclaimer_text' ? 'disclaimer_bucket' : 'bde_photos_bucket'}
                        uploadToS3={true}
                        uploadObj={{file:null}}
                        upload_type_name = {currentItem.label}
                        successCallback = {this.successCallback.bind(this)}
                        failureCallback = {this.failureCallback.bind(this)}
                    ></UploadComponent>
                </div>
            )
        }
       
        if(currentItem && currentItem.text_field){
            viewJSX.push(<div className={classes.popOverDiv}>
                <TextValidator
                    label={<label>
                        {currentItem.label}
                    </label>}
                    fullWidth
                    id={currentItem._id}
                    name={currentItem.name}
                    placeholder={currentItem.placeholder}
                    disabled={currentItem.disabled}
                    value={currentItem.value}
                    onChange={this.handleChange}

                    margin="dense"
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true,
                        style: { fontSize: 20, top: '-15px', fontWeight: 'bold' }
                    }}
                />    
            </div>)
        }
       
        if(currentItem && currentItem.color_picker){
            viewJSX.push(<div className={classes.popOverDiv}>
                <Grid container style={{flexWrap:"nowrap",justifyContent:"center"}}> 
                    <Box 
                        className={classes.colorBox} 
                        style={{ backgroundColor: currentItem.value }} 
                        disabled={currentItem.disabled}
                    />
                    { !currentItem.disabled ?  <FormControl 
                        className={classes.colorPickerDiv}
                    >
                        <ChromePicker 
                            color={currentItem.value}
                            onChange={(color)=> this.handleColorChange(color,currentItem.name) } />
                    </FormControl> : ""}
                   
                </Grid>
            </div>)
        }
 
        return viewJSX
    }

    render() {
        const { classes, open } = this.props;
        return (
            <Dialog
                open={open}
                disableBackdropClick
                disableEscapeKeyDown
                
                fullWidth={true}
                maxWidth="md"
                classes={{
                    paper: classes.mainDialog,
                }}
            >
            <DialogContent classes={{ root: classes.dialogContent}}> 
                <Tabs 
                    aria-label="Setting tabs"
                    value={this.state.activeTab} 
                    onChange={this.handleTabChange} 
                >
                    {Object.keys(this.state.items).map((item,i)=>{
                        let name = item.split("_");
                        let label = name && name[0][0].toUpperCase() + name.join(" ").substring(1)
                        return(<Tab label={label} className={classes.tabs} />)
                    })}
                </Tabs>

                {this.renderTabSpecificView(classes)}
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button 
                    color="primary" 
                    variant="contained" 
                    className={classes.dialogButton}
                    onClick={(e)=>this.props.onSettingsPopoverClose(this.state.items)} 
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
        )
    }
}

EventPopover.propTypes = {
    className: PropTypes.string,
};

export default withStyles(useStyles)(EventPopover);